const state = {
    pagination: { multiSort: true },
    sorting: [],
    sortItems: [],
    searchText: '',
    columnSearch: {},
}


const actions = {
    setSearchText({ commit }, search) {
        commit('setSearchText', search)
    },

    setColumnSearch({ commit }, searchObject) {
        commit('setColumnSearch', searchObject)
    },

    setSorting({ commit }, sorting) {
        commit('setSorting', sorting)
    },

    setSortOptions({ commit }, options) {
        commit('setSortOptions', options)
    },

    setSortItems({ commit }, items) {
        commit('setSortItems', items)
    },
}


const mutations = {
    setSearchText(tabelState, search) {
        tabelState.searchText = search
    },

    setColumnSearch(tabelState, searchObject) {
        if (searchObject !== null) {
            const { column, input } = searchObject
            const newColumnSearch = { ...tabelState.columnSearch }
            if (input !== null) {
                newColumnSearch[column] = input
                tabelState.columnSearch = newColumnSearch
            } else {
                delete newColumnSearch[column]
                tabelState.columnSearch = newColumnSearch
            }
        } else {
            tabelState.columnSearch = {}
        }
    },

    setSorting(tabelState, sorting) {
        if (sorting) {
            const sortBy = sorting.map(x => x[0])
            const sortDesc = sorting.map(x => (x.length > 1 && x[1] ? x[1] : false))
            tabelState.sorting = sorting.toString()
            tabelState.pagination.sortBy = sortBy
            tabelState.pagination.sortDesc = sortDesc
            tabelState.pagination.itemsPerPage = -1
        } else {
            tabelState.sorting = sorting
            tabelState.pagination.sortBy = sorting
            tabelState.pagination.sortDesc = false
            tabelState.pagination.itemsPerPage = -1
        }
    },

    setSortOptions(tabelState, options) {
        tabelState.pagination = options
    },

    setSortItems(tabelState, items) {
        tabelState.sortItems = items
    },
}


export const table = {
    namespaced: true,
    state,
    actions,
    mutations,
}
